/**
 * Admin Gmail Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  GmailDeploymentStatusSchema,
  GmailMigrationStatusResponseSchema,
  MigrateGmailWebhookBodySchema,
  MigrateGmailWebhookResponseSchema
} from "./schemas/gmail-migration.schemas";

export const ZAdminGmailMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/gmail/status",
    Response: ApiSuccessSchema(GmailMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/gmail/migrate",
    Body: MigrateGmailWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateGmailWebhookResponseSchema)
  }
} as const;

export type TApiAdminGmailMigration = InferSchemas<typeof ZAdminGmailMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================
//
// The producer (`GetGmailStatusUseCase`) declares its return as these, so `tsc`
// compares what it builds against the contract inside the use case rather than
// only at the controller — a comparison against a locally-declared parallel
// interface proves nothing.

export type GmailDeploymentStatus = z.infer<typeof GmailDeploymentStatusSchema>;
export type GmailMigrationStatusResponse = z.infer<typeof GmailMigrationStatusResponseSchema>;
